import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import * as FileSaver from 'file-saver/FileSaver';

interface ClipboardNavigator extends Navigator {
  clipboard?: { writeText(text: string): Promise<void> };
}

const COPY_EVENT = 'copy';
const TEXT_MIME_TYPE = 'text/plain';
const LOG_MIME_TYPE = 'text/plain;charset=utf-8';
const LOG_FILE_PREFIX = 'planfix-import-';
const LOG_FILE_EXTENSION = '.txt';

@Injectable()
export class PlanfixImportExportService {
  constructor(@Inject(DOCUMENT) private browserDocument: Document) {}

  download(runId: string, text: string): void {
    const blob = new Blob([text], { type: LOG_MIME_TYPE });
    FileSaver.saveAs(blob, LOG_FILE_PREFIX + runId + LOG_FILE_EXTENSION, true);
  }

  copy(text: string, isCurrent: () => boolean): Promise<boolean> {
    const browserWindow = this.browserDocument.defaultView;
    const browserNavigator = browserWindow && browserWindow.navigator as ClipboardNavigator;
    if (browserNavigator && browserNavigator.clipboard) {
      try {
        return browserNavigator.clipboard.writeText(text).then(
          () => isCurrent(),
          () => isCurrent() && this.copyLegacy(text),
        );
      } catch (error) {
        return Promise.resolve(isCurrent() && this.copyLegacy(text));
      }
    }
    return Promise.resolve(isCurrent() && this.copyLegacy(text));
  }

  private copyLegacy(text: string): boolean {
    let copied = false;
    const onCopy = (event: ClipboardEvent) => {
      if (event.clipboardData) {
        event.clipboardData.setData(TEXT_MIME_TYPE, text);
        event.preventDefault();
        copied = true;
      }
    };
    this.browserDocument.addEventListener(COPY_EVENT, onCopy);
    try {
      return this.browserDocument.execCommand(COPY_EVENT) && copied;
    } catch (error) {
      return false;
    } finally {
      this.browserDocument.removeEventListener(COPY_EVENT, onCopy);
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/planfix-import-journal/planfix-import-export.service.ts